import { type Shape }                 from '@tokamap/core';
import { type RailingStyle }          from '@tokamap/core';
import { type SurfaceBorder }         from '@tokamap/core';
import { type SurfaceMaterial }       from '@tokamap/core';
import { type SurfaceScale }          from '@tokamap/core';
import { type SurfaceScatterDensity } from '@tokamap/core';

const SURFACED_KINDS: Shape['shapeKind'][] = ['polygon', 'rectangle', 'circle'];
const RAILED_KINDS: Shape['shapeKind'][] = [...SURFACED_KINDS, 'line'];

export const NONE = 'none' as const;

export function canHaveSurface(shapes: Shape[]): boolean {
	return shapes.length > 0 && shapes.every(shape => SURFACED_KINDS.includes(shape.shapeKind ?? 'polygon') && !shape.image);
}

export function surfaceBlockedByImage(shapes: Shape[]): boolean {
	return shapes.some(shape => !!shape.image) && shapes.every(shape => SURFACED_KINDS.includes(shape.shapeKind ?? 'polygon'));
}

export function canHaveRailing(shapes: Shape[]): boolean {
	return shapes.length > 0 && shapes.every(shape => RAILED_KINDS.includes(shape.shapeKind ?? 'polygon') && !shape.image);
}

export const MATERIAL_LABELS: Record<SurfaceMaterial, string> = {
	grass: 'Herbe',
	dirt: 'Terre',
	sand: 'Sable',
	gravel: 'Gravier',
	cobbles: 'Pavés',
	slabs: 'Dalles',
	deck: 'Terrasse bois',
	chips: 'Copeaux de bois',
	concrete: 'Béton',
};

export const SCATTER_HINTS: Partial<Record<SurfaceMaterial, string>> = {
	grass: 'touffes et fleurs',
	dirt: 'cailloux et herbe sèche',
	sand: 'galets clairs et herbe sèche',
	gravel: 'cailloux et quelques herbes',
	chips: "feuilles mortes et morceaux d'écorce",
};

export const SCALE_OPTIONS: { value: SurfaceScale; label: string; }[] = [
	{ value: 'fine', label: 'Fin' },
	{ value: 'normal', label: 'Normal' },
	{ value: 'large', label: 'Grand' },
];

export const SCATTER_OPTIONS: { value: SurfaceScatterDensity | typeof NONE; label: string; }[] = [
	{ value: NONE, label: 'Aucun' },
	{ value: 'light', label: 'Léger' },
	{ value: 'dense', label: 'Dense' },
];

export const TINT_OPTIONS = [
	{ value: 'natural', label: 'De la matière' },
	{ value: 'tinted', label: 'Du fond' },
];

export const BORDER_LABELS: Record<SurfaceBorder, string> = {
	stone: 'Pierres',
	wood: 'Bois',
	pebbles: 'Galets',
	fade: 'Fondu dans le sol voisin',
};

export const RAILING_LABELS: Record<RailingStyle, string> = {
	'glass': 'Garde-corps vitré',
	'glass-high': 'Garde-corps vitré haut',
	'mesh': 'Grillage',
	'bars': 'Barreaux',
	'wood': 'Bois',
	'wood-white': 'Bois blanc',
	'hedge': 'Haie basse',
	'hedge-high': 'Haie haute',
};
